module.exports = __webpack_public_path__ + "img/p3.04fa943a.png";